import React, { useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Card, Tab, Form, Button, Nav } from 'react-bootstrap'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Formik } from 'formik';
import * as Yup from 'yup';
import swal from "sweetalert";

//image
import defaultImage from '../../../assets/images/user/defultimg.png'
import { useDispatch, useSelector } from 'react-redux';
import { userProfile, userProfileedit } from '../../../store/user/userThunk';
import { reseteditProfile } from '../../../store/user/userSlice';
import ChangePasswordForm from './ChangePasswordForm';
import { toast } from 'react-toastify';

const UserProfileEdit = () => {
  const [img1, setImg1] = useState(""); // Add logic to update image
  const inputFile = useRef(null);
  const { state } = useLocation();

  let { editprofile, profile } = useSelector((state) => state.userservice)
  let dispatch = useDispatch()
  const navigate = useNavigate();

  console.log(state, "state")
  const onButtonClick = () => {
    inputFile.current.click();
  };

  useEffect(() => {
    if (editprofile) {
      toast.success("Profile updated successfully!");
      dispatch(reseteditProfile());
      navigate("/dashboards/app/profile");
    }
  }, [dispatch, editprofile, navigate]);

  useEffect(() => {
    dispatch(userProfile())
      .unwrap()
      .then(() => {
        console.log("Profile fetched successfully");
      })
      .catch((err) => {
        console.log(err)
      });
  }, [dispatch]);



  // Initial form values
  const initialValues = {
    fullName: profile ? profile?.fullName : '',
    userName: profile ? profile?.userName : '',
    email: profile ? profile?.email : '',
    profileImage: null,
    gender: profile ? profile?.gender : '',
    dob: profile ? profile?.dob : '',
    phoneNumber: profile ? profile?.phoneNumber : '',
    country: profile ? profile?.country : '',
    state: profile ? profile?.state : '',
    city: profile ? profile?.city : '',
    id: profile ? profile?._id : null
  };

  // Validation schema with Yup
  const validationSchema = Yup.object({
    fullName: Yup.string().required('Full Name is required'),
    userName: Yup.string().required('User Name is required'),
    email: Yup.string().email('Invalid email format').required('Email is required'),
    gender: Yup.string().required('Gender is required'),
    dob: Yup.date().required('Date of Birth is required'),
    phoneNumber: Yup.string().required('Phone Number is required'),
    country: Yup.string().required('Country is required'),
    state: Yup.string().required('State is required'),
    city: Yup.string().required('City is required'),
  });

  // Form submission handler
  const onSubmit = (values) => {
    dispatch(userProfileedit(values))
  };

  const handleFileUpload = async (e, setFieldValue) => {
    const { files } = e.target;
    setFieldValue(files)

  }

  let getProfile = async () => {
    await dispatch(userProfile())
  }
  return (
    <>
      <div className='content-inner'>
        <Container>
          <Tab.Container defaultActiveKey="first">
            <Row>
              <Col lg="12">
                <Card>
                  <Card.Body className="p-0">
                    <div>
                      <Nav as="ul" variant="pills" className="iq-edit-profile row mb-0">
                        <Nav.Item as="li" className="col-md-3 p-0">
                          <Nav.Link eventKey="first" role="button">
                            Personal Information
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item as="li" className="col-md-3 p-0">
                          <Nav.Link eventKey="second" role="button">
                            Change Password
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={12}>
                {/* <div className="iq-edit-list-data"> */}
                <Tab.Content>
                  <Tab.Pane eventKey="first" className="fade show">
                    <Card>
                      <Card.Header className="d-flex justify-content-between">
                        <div className="header-title">
                          <h4 className="card-title">Personal Information</h4>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <Formik
                          initialValues={initialValues}
                          validationSchema={validationSchema}
                          onSubmit={onSubmit}
                        >
                          {({ values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched }) => (
                            <Form onSubmit={handleSubmit}>
                              <Form.Group className="form-group align-items-center">
                                <Col md="12">
                                  <div className="profile-img-edit">
                                    {/* Display selected image or fallback to default */}
                                    <img
                                      className="profile-pic"
                                      src={values.profileImage ? URL.createObjectURL(values.profileImage) : defaultImage}
                                      alt="profile-pic"
                                      style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                    />
                                    <div className="p-image d-flex align-items-center justify-content-center">
                                      <span className="material-symbols-outlined" onClick={onButtonClick}>edit</span>
                                      <input
                                        className="file-upload"
                                        type="file"
                                        accept="image/*"
                                        ref={inputFile}
                                        onChange={(event) => {
                                          // Handle the image selection and update Formik state
                                          const file = event.target.files[0];
                                          if (file) {
                                            setFieldValue("profileImage", file);
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Col>
                              </Form.Group>

                              <Row className="align-items-center">
                                {/* Full Name */}
                                <Form.Group className="form-group col-sm-6">
                                  <Form.Label htmlFor="fullName">Full Name:</Form.Label>
                                  <Form.Control
                                    type="text"
                                    id="fullName"
                                    placeholder="John Doe"
                                    value={values.fullName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.fullName && errors.fullName}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.fullName}
                                  </Form.Control.Feedback>
                                </Form.Group>

                                {/* User Name */}
                                <Form.Group className="form-group col-sm-6">
                                  <Form.Label htmlFor="userName">User Name:</Form.Label>
                                  <Form.Control
                                    type="text"
                                    id="userName"
                                    placeholder="john.doe"
                                    value={values.userName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.userName && errors.userName}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.userName}
                                  </Form.Control.Feedback>
                                </Form.Group>

                                {/* Email */}
                                <Form.Group className="form-group col-sm-6">
                                  <Form.Label htmlFor="email">Email:</Form.Label>
                                  <Form.Control
                                    type="email"
                                    id="email"
                                    placeholder="johndoe@example.com"
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.email && errors.email}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.email}
                                  </Form.Control.Feedback>
                                </Form.Group>

                                {/* Phone Number */}
                                <Form.Group className="form-group col-sm-6">
                                  <Form.Label htmlFor="phoneNumber">Phone Number:</Form.Label>
                                  <Form.Control
                                    type="text"
                                    id="phoneNumber"
                                    placeholder="123-456-7890"
                                    value={values.phoneNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.phoneNumber && errors.phoneNumber}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.phoneNumber}
                                  </Form.Control.Feedback>
                                </Form.Group>

                                {/* Gender */}
                                <Form.Group className="form-group col-sm-6">
                                  <Form.Label>Gender:</Form.Label>
                                  <Form.Check
                                    inline
                                    label="Male"
                                    type="radio"
                                    name="gender"
                                    id="genderMale"
                                    value="Male"
                                    checked={values.gender === 'Male'}
                                    onChange={handleChange}
                                  />
                                  <Form.Check
                                    inline
                                    label="Female"
                                    type="radio"
                                    name="gender"
                                    id="genderFemale"
                                    value="Female"
                                    checked={values.gender === 'Female'}
                                    onChange={handleChange}
                                  />
                                  {touched.gender && errors.gender && (
                                    <div className="invalid-feedback d-block">{errors.gender}</div>
                                  )}
                                </Form.Group>

                                {/* Date of Birth */}
                                <Form.Group className="form-group col-sm-6">
                                  <Form.Label htmlFor="dob">Date of Birth:</Form.Label>
                                  <Form.Control
                                    type="date"
                                    id="dob"
                                    value={values.dob}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.dob && errors.dob}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.dob}
                                  </Form.Control.Feedback>
                                </Form.Group>

                                {/* Country */}
                                <Form.Group className="form-group col-sm-6">
                                  <Form.Label htmlFor="country" className="form-label">Country:</Form.Label>
                                  <Form.Control
                                    id="country"
                                    value={values.country}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.country && errors.country}
                                  >
                                  </Form.Control>
                                  {touched.country && errors.country && (
                                    <div className="invalid-feedback">{errors.country}</div>
                                  )}
                                </Form.Group>

                                <Form.Group className="form-group col-sm-6">
                                  <Form.Label htmlFor="state" className="form-label">State:</Form.Label>
                                  <Form.Control
                                    id="state"
                                    value={values.state}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.state && errors.state}
                                  >
                                  </Form.Control>
                                  {touched.state && errors.state && (
                                    <div className="invalid-feedback">{errors.state}</div>
                                  )}
                                </Form.Group>

                                <Form.Group className="form-group col-sm-6">
                                  <Form.Label htmlFor="city" className="form-label">City:</Form.Label>
                                  <Form.Control
                                    type="text"
                                    id="city"
                                    value={values.city}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.city && errors.city}
                                  />
                                  {touched.city && errors.city && (
                                    <div className="invalid-feedback">{errors.city}</div>
                                  )}
                                </Form.Group>

                                {/* Address */}
                                <Form.Group className="form-group col-sm-12">
                                  <Form.Label htmlFor="address">Address:</Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={5}
                                    id="address"
                                    placeholder="37 Cardinal Lane, Petersburg, VA 23803, United States of America, Zip Code: 85001"
                                    value={values.address}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.address && errors.address}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors.address}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </Row>

                              <Button type="submit" className="btn btn-primary me-2">Submit</Button>
                              <Button type="reset" variant="" className="btn-danger-subtle">Cancel</Button>
                            </Form>
                          )}
                        </Formik>

                      </Card.Body>
                    </Card>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second" className="fade show">
                    <ChangePasswordForm />
                  </Tab.Pane>

                </Tab.Content>
                {/* </div> */}
              </Col>
            </Row>
          </Tab.Container>
        </Container>
      </div >
    </>
  )

}

export default UserProfileEdit;